var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7436 6.276C58.404 5.06483 57.7423 3.9683 56.8289 3.10297C55.8897 2.21103 54.7387 1.57301 53.4843 1.24912C48.79 0.0123893 29.9825 0.0123895 29.9825 0.0123895C22.1419 -0.0767735 14.3032 0.315388 6.51067 1.18666C5.25631 1.53448 4.1074 2.18676 3.16612 3.08548C2.24124 3.97493 1.57133 5.07175 1.22138 6.2735C0.380724 10.8001 -0.0277233 15.3962 0.00154275 20C-0.0284532 24.5996 0.378992 29.1943 1.22138 33.7265C1.56383 34.9232 2.23124 36.015 3.15862 36.897C4.08599 37.779 5.24084 38.4161 6.51067 38.7534C11.2675 39.9876 29.9825 39.9876 29.9825 39.9876C37.8331 40.0769 45.6818 39.6847 53.4843 38.8133C54.7387 38.4894 55.8897 37.8514 56.8289 36.9595C57.7419 36.0943 58.4029 34.9976 58.7411 33.7864C59.6037 29.2616 60.0232 24.6636 59.9935 20.0575C60.0583 15.4318 59.6395 10.8121 58.7436 6.2735V6.276ZM24.0033 28.5547V11.4478L39.6512 20.0025L24.0033 28.5547Z",
    fill: "#4A3AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0a34f9d5cc9077ca19a36d6f93d69f81.svg";
export { ForwardRef as ReactComponent };